var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{ref:"footer",staticClass:"footer"},[_c('div',{staticClass:"container"},[_vm._m(0),_c('social')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h4',[_c('i',{staticClass:"far fa-copyright"}),_vm._v(" 2018 Privacy Policy")])
}]

export { render, staticRenderFns }